import { DolaThemes } from '../../../styles/types'
import { errorColor } from '../../../styles/variables'
import { ButtonVariants } from '../types'

type Theme = Record<
  DolaThemes,
  Record<ButtonVariants, Record<'background' | 'border' | 'text', string>>
>

const buttonTheme: Theme = {
  dark: {
    primary: {
      background: 'linear-gradient(to right, #1B0C3C, #5432D3)',
      border: '#5432D3',
      text: 'white',
    },
    secondary: {
      background: '#0B0B0B',
      border: '#5432D3',
      text: 'white',
    },
    disabled: {
      background: '#0B0B0B',
      border: '#0B0B0B',
      text: 'rgba(255, 255, 255, .6)',
    },
    warning: {
      background: errorColor,
      border: '#FF4D41',
      text: 'white',
    },
  },
  light: {
    primary: {
      background: 'linear-gradient(to right, #EAB5FF, #D4CFFF)',
      border: '#0B0B0B',
      text: '#0B0B0B',
    },
    secondary: {
      background: 'white',
      border: '#0B0B0B',
      text: '#0B0B0B',
    },
    disabled: {
      background: '#DDDDDD',
      border: '#999999',
      text: '#999999',
    },
    warning: {
      background: errorColor,
      border: '#FF4D41',
      text: 'white',
    },
  },
}

export default buttonTheme
